import { initializeApp, setLogLevel } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator, browserLocalPersistence } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Suppress Firebase logs
setLogLevel("silent");

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Set auth persistence
auth.setPersistence(browserLocalPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});

// Function to determine local IP or hostname
const getLocalIpAddress = () => {
  return window.location.hostname === "localhost" || window.location.hostname.startsWith("192.")
    ? window.location.hostname
    : "localhost"; // Default to "localhost" if not running on LAN
};

// Connect to emulators in development mode
if (process.env.NODE_ENV === "development") {
  const localIp = getLocalIpAddress();

  console.log("Connecting to Firebase emulators...");
  console.log("Firestore Emulator URL:", `http://${localIp}:8080`);
  console.log("Auth Emulator URL:", `http://${localIp}:9099`);
  console.log("Functions Emulator URL:", `http://${localIp}:5001`);
  console.log("Storage Emulator URL:", `http://${localIp}:9199`);

  // Connect to Firestore Emulator
  connectFirestoreEmulator(db, localIp, 8080);

  // Connect to Auth Emulator
  connectAuthEmulator(auth, `http://${localIp}:9099`);

  // Connect to Functions Emulator
  connectFunctionsEmulator(functions, localIp, 5001);

  // Connect to Storage Emulator
  connectStorageEmulator(storage, localIp, 9199);
}

export { app, db, auth, functions, analytics, storage };